import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, E = ({ size: e = 16, useVw: l, useRem: n, color: o, withColor: c, removeClassName: t, disableSSR: p, style: r, ...m }) => {
  const x = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ a.createElement(f, { disableSSR: p }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-VIP", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), height: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: x, fill: "none", ...m }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-VIP"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: c ? i(o, 0, "#262933") : "#262933",
        datafollowfill: c ? i(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M11.873 13.38a.9.9 0 1 0-1.346 1.196l4.8 5.4a.9.9 0 0 0 1.346 0l4.8-5.4a.9.9 0 1 0-1.346-1.195L16 18.024l-4.127-4.643Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M10.05 4.6a2.18 2.18 0 0 0-1.602.693.9.9 0 0 0-.056.067l-4.785 6.33a2.009 2.009 0 0 0 .06 2.733l11.216 12.181a1.5 1.5 0 0 0 2.234 0l11.215-12.181c.734-.766.76-1.94.061-2.733l-4.785-6.33a.896.896 0 0 0-.056-.067 2.18 2.18 0 0 0-1.601-.693H10.049Zm-5.03 8.205 4.772-6.312a.388.388 0 0 1 .257-.093h11.902c.107 0 .197.04.257.093l4.772 6.312a.9.9 0 0 0 .056.068.219.219 0 0 1 .064.153.22.22 0 0 1-.069.153.859.859 0 0 0-.016.017L16 25.16 4.985 13.196a1.073 1.073 0 0 0-.016-.017.223.223 0 0 1-.069-.153c0-.046.015-.1.064-.154a.902.902 0 0 0 .056-.067Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, h = E;
export {
  h as default
};
